<template>
  <div class="salesOrder MSGsalesOrder rel flex font">
    <div class="body abs flex">
      <!-- 第一页面 -->
      <div class="firstPage w100p flex aic jc-sb">
        <div class="bigTable">
          <div class="topBox">
            <div class="flex aic jc-sb">
              <div class="flex aic">
                <span
                  class="flex aic jc-c"
                  style="height: 34px;width: 34px;background-color: #EA86BC;border-radius: 4px;"
                >
                  <i class="iconfont icon-a-SalesOrders2_huaban1 f22 fff"></i>
                </span>
                <div class="flex fdc ml-10 rel">
                  <span class="f12 f333">{{ $t('Order.salesOrder') }}</span>
                  <div class="flex aic fwb f18 f333">
                    <span>
                      {{ store.lang == 'en-us' ?
                      `${searchOrderObj.userInfoName} ${$t('Order.orderSalesOrders')}` :
                      `${searchOrderObj.userInfoName}${$t('Order.orderSalesOrders')}` }}
                    </span>
                  </div>
                  <!-- <Dropdown
                    :data="teamList"
                    :id="searchOrderObj.userInfoID"
                    :prop="{ id: 'id', value: 'name' }"
                    @click-row="getTeamUserID"
                    @input="getTeamList1"
                    @scroll="getTeamList2"
                  >
                    <div class="flex aic fwb f18 f333">
                      <span>
                        {{ store.lang == 'en-us' ?
                        `${searchOrderObj.userInfoName} ${$t('Order.orderSalesOrders')}` :
                        `${searchOrderObj.userInfoName}${$t('Order.orderSalesOrders')}` }}
                      </span>
                      <i
                        class="iconfont icon-xiangyou ml-5 mt-5"
                        style="font-size: 10px;transform: scale(0.8);"
                      ></i>
                    </div>
                  </Dropdown>-->
                </div>
              </div>
            </div>
            <div class="flex aic jc-sb" style="margin-top: 9px">
              <div class="flex aic w100p">
                <!-- <el-select placeholder="Select The Sources" class="mr-10" style="width:10%;">
                  <el-option />
                </el-select>-->
                <el-select
                  v-model="searchOrderObj.Sources"
                  @change="getOrderList(1, '', searchOrderObj.userInfoID)"
                  @focus="pubData.getOrderFromList('purchaseorder')"
                  v-Loadmore="pubData.getOrderFromList1"
                  :filter-method="pubData.remoteOrderFromList"
                  @visible-change="pubData.cantPendingRequest"
                  :loading="selectLoading"
                  clearable
                  filterable
                  :placeholder="$t('slack.source')"
                  class="mr-5"
                  style="width: 15%"
                >
                  <el-option
                    v-for="item in orderFromList"
                    :key="item.website_id"
                    :label="item.website_title"
                    :value="item.website_id"
                  />
                </el-select>
                <el-select
                  v-model="searchOrderObj.orderContact"
                  @change="getOrderList(1, '', searchOrderObj.userInfoID)"
                  v-Loadmore="pubData.getClentAndSupper1"
                  @focus="pubData.getClentAndSupper(0, 0)"
                  @visible-change="pubData.cantPendingRequest"
                  :remote-method="pubData.remoteClentAndSupper"
                  :loading="selectLoading"
                  remote
                  remote-show-suffix
                  clearable
                  filterable
                  :placeholder="$t('slack.Contacts')"
                  class="mr-10"
                  style="width: 15%"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-select
                  v-model="searchOrderObj.orderCountry"
                  @change="getOrderList(1, '', searchOrderObj.userInfoID)"
                  @focus="pubData.getCountry"
                  @visible-change="pubData.cantPendingRequest"
                  v-Loadmore="pubData.getCountry1"
                  :remote-method="pubData.remoteCountry"
                  :loading="selectLoading"
                  clearable
                  remote
                  remote-show-suffix
                  filterable
                  :placeholder="$t('slack.Countrys')"
                  class="mr-10"
                  style="width: 15%"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-select
                  v-model="searchOrderObj.orderType"
                  @change="getOrderList(1, '', searchOrderObj.userInfoID)"
                  clearable
                  :placeholder="$t('slack.Type')"
                  class="mr-10"
                  style="width: 15%"
                >
                  <el-option
                    v-for="item in orderTypeList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  />
                </el-select>
                <el-select
                  v-model="searchOrderObj.orderType1"
                  @change="getOrderList(1, '', searchOrderObj.userInfoID)"
                  clearable
                  :placeholder="$t('slack.FormText')"
                  class="mr-10"
                  style="width: 15%"
                >
                  <el-option
                    v-for="item in orderTypeList1"
                    :key="item.type"
                    :value="item.type"
                    :label="item.typeText"
                  />
                </el-select>
                <el-cascader
                  ref="addressLevelRef"
                  v-model="searchOrderObj.orderStatus"
                  :options="statusList"
                  :props="props1"
                  @change="closeAddRess1"
                  clearable
                  :placeholder="$t('slack.StatusText')"
                  class="mr-10"
                  style="width: 15%"
                ></el-cascader>
                <!-- <div class="mr-10" style="width:13%">
                  <el-date-picker
                    v-model="searchOrderObj.orderDate"
                    @change="getOrderList(1, '', searchOrderObj.userInfoID)"
                    clearable
                    type="daterange"
                    format="YYYY/MM/DD"
                    value-format="YYYY-MM-DD"
                    unlink-panels
                    :range-separator="$t('Order.orderDateTo')"
                    :start-placeholder="$t('Order.orderStartDate')"
                    :end-placeholder="$t('Order.orderEndDate')"
                    :shortcuts="shortcuts"
                    size="size"
                    style="width:100%"
                  />
                </div>-->
                <el-input
                  v-model="searchOrderObj1.fuzzySearch"
                  @input="topSearch"
                  clearable
                  :placeholder="$t('Order.orderKeyWords')"
                  :prefix-icon="Search"
                  class="mr-10"
                  style="width: 15%"
                />
                <el-checkbox
                  v-model="searchOrderObj.checkBox"
                  @change="getOrderList(1, '', searchOrderObj.userInfoID)"
                  :label="$t('Order.orderFromContact1')"
                  size="large"
                />
              </div>
              
            </div>
          </div>
          <!-- 表格 -->
          <div class="bodeytable pl-15 mt-15 mr-15">
            <!-- v-el-table-infinite-scroll="getOrderList1" -->
            <el-table
              ref="orderRef"
              :data="getOrderObj.orderList"
              v-loading="getOrderObj.loading"
              @current-change="handleCurrentChange"
              @selection-change="handleSelectionChange"
              :header-cell-style="{
                              'background-color': '#F2F4F7', 'font-weight': 'bold',
                              'height': '40px', 'fontSize': '14px'
                          }"
              border
              height="100%"
            >
              <template #empty>
                <Empty :size="150" :color="'#999999'">
                  <span class="f20 mt-30" style="color:#999999">No data</span>
                </Empty>
              </template>
              <el-table-column type="selection" width="35"/>
              <el-table-column label="ID" show-overflow-tooltip>
                <template #default="{ row }">
                  <div class="flex aic jc-sb" style="width: 100%;">
                    <span
                      @click="getOrderID(row)"
                      style="color: #3370ff;
                                          text-decoration:underline;cursor: pointer;"
                      class="Tip"
                    >{{ row.PI_name }}</span>
                    <span
                      v-show="row.isClentState == 2"
                      class="fromName flex aic jc-c ml-10 f12 Tip"
                    >From {{ row.from_contact }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip>
                <template #header>
                  <span class="ovhidden1 f333">{{ $t("Order.OrderTableContact") }}</span>
                </template>
                <template #default="{ row }">
                  <span style="color:#555555;">{{ row.clientName ? row.clientName : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="85">
                <template #header>
                  <span class="ovhidden1 f333">{{ $t('Order.Account') }}</span>
                </template>
                <template #default="{ row, $index }">
                  <span
                    :class="{ 'fwb': row.is_read == 0 }"
                  >{{ row.customer_company ? row.customer_company : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="150">
                <template #header>
                  <span class="ovhidden1 f333">{{ $t("Order.OrderTableCountry") }}</span>
                </template>
                <template #default="{ row }">
                  <span>{{ row.iso_code_2 ? row.iso_code_2 : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="items" width="65">
                <template #header>
                  <span class="ovhidden1 flex f333">{{ $t("Order.OrderTableItems") }}</span>
                </template>
                <template #default="{ row }">
                  <span>{{ row.items ? row.items : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="OrderType_text" show-overflow-tooltip>
                <template #header>
                  <span class="ovhidden1 f333">{{ $t("Order.OrderTableType") }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="PI_type_text" show-overflow-tooltip>
                <template #header>
                  <span class="ovhidden1 f333">{{ $t('Order.OrderType1') }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="80">
                <template #header>
                  <span class="ovhidden1 f333">{{ $t('Order.OrderTableSales') }}</span>
                </template>
                <template #default="{ row }">
                  <span>{{ row.user_name ? row.user_name : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip>
                <template #header>
                  <span class="ovhidden1 f333">{{ $t('Order.Source') }}</span>
                </template>
                <template #default="{ row, $index }">
                  <span
                    :class="{ 'fwb': row.is_read == 0 }"
                  >{{ row.website_title ? row.website_title : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status_text" label="Status" show-overflow-tooltip>
                <template #header>
                  <span class="ovhidden1 f333">{{ $t('Order.OrderTableStatus') }}</span>
                </template>
                <template #default="{ row }">
                  <div class="flex aic">
                    <div class="TableStatusBox iconBox flex aic jc-c">
                      <!-- <img
                        v-show="row.status == 1"
                        src="../logosvg/start.svg"
                        style="width:18px;height:18px;"
                      />
                      <img
                        v-show="row.status == 2"
                        src="../logosvg/ing.svg"
                        style="width:18px;height:18px;"
                      />
                      <img
                        v-show="row.status == 3"
                        src="../logosvg/end.svg"
                        style="width:18px;height:18px;"
                      />
                      <span class="iconfont icon-gou color0D7C54" v-if="row.status == 3"></span>
                      <span class="iconfont icon-exclamation colorcccccc" style="display: none;"></span>-->
                      <Circularprogressbar :State="row.status"></Circularprogressbar>
                    </div>
                    <div class="Tip">
                      <span style="margin-left: 5px;">{{ row.status_text }}</span>
                      <span
                        v-show="row.status_list.State"
                        style="margin-left: 5px;"
                      >{{ row.status_list.State }} {{ row.status_list.item }}/{{ row.items }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="CreateTime" show-overflow-tooltip width="140">
                <template #header>
                  <span class="ovhidden1 f333">{{ $t('Order.OrderTableCreatedDate') }}</span>
                </template>
                <template #default="{ row }">
                  <span calss="ovhidden">{{ row.CreateTime }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="botoomHeight flex jc-end mt-15 mb-15">
            <el-pagination
              v-model:current-page="currentPage"
              :total="pageTotal"
              v-model:page-size="pageSize"
              pager-count="5"
              :page-sizes="[10, 15, 17, 25, 30, 35, 40]"
              @current-change="changeCurrPage"
              @size-change="changeSize"
              layout="total, sizes, prev, pager, next, jumper"
            />
          </div>
        </div>
        <!-- 右边关闭三角形 -->
      </div>
    </div>
  </div>
</template>
<script setup>
import * as utils from "../utils";
import { useRouter } from "vue-router";
import Empty from "./Empty.vue";
import i18n from "@/assets/lang";
import useClipboard from "vue-clipboard3";
import * as pubData from "./orderData.js";
import NoData from "./NoData.vue";
import { Search } from "@element-plus/icons-vue";
import { useDemoStore } from "@/pinia/index";
import * as api from "@/api/apiPayOrder/index";
import { Kernaldec } from "@/hooks/useDecrypt";
import { ElMessage, ElMessageBox } from "element-plus";
import Circularprogressbar from "./Circularprogressbar.vue";
import { HomeStore } from "@/slack/index.js";
import { ref, reactive, onMounted, onUnmounted, nextTick, computed } from "vue";
import Dropdown from "@/components/Dropdown/Dropdown.vue";
const store = useDemoStore();
const router = useRouter();
const routerID = router.currentRoute.value.query.fromOrderID;
const routerName = router.currentRoute.value.query.fromOrderName;
// 权限对象
const LimitObj = {};

// 切换状态变量
let selectList1 = [];
const isTransaction = (val) => {
  store.changeOrderShow(val);
  if (!val) {
    selectList1 = selectList.value?.filter(
      (item) => item.order_id == orderID.value
    );
    selectList.value = [];
  } else {
    selectList.value = selectList1?.length == 1 ? selectList1 : [];
    getOrderObj.orderList?.forEach((item) => {
      if (item.order_id == orderID.value) {
        item.checkState = true;
      }
    });
  }
};

// 新建订单
const NewSelectionRef = ref();
const createSorder = () => {
  NewSelectionRef.value.newSelectionState = true;
};
/************ 获取订单开始 ************/
let orderRef = ref();
const handleCurrentChange = (e) => {
  if (e) {
    HomeStore().selectData = e;
    orderRef.value.toggleRowSelection(e, true);
  }
};
const handleSelectionChange = (e) => {
  if (e.length > 0) {
    orderRef.value.setCurrentRow(e[e.length - 1]);
    e.map((item, index) => {
      if (index == e.length - 1) {
        orderRef.value.toggleRowSelection(item, true);
      } else {
        orderRef.value.toggleRowSelection(item, false);
      }
    });
  } else {
    orderRef.value.setCurrentRow("");
    HomeStore().selectData = "";
  }
};
// 下拉框model
const searchOrderObj = reactive({
  Sources: "",
  ContactOwner: "",
  orderContact: "",
  orderCountry: "",
  orderType: "",
  orderType1: "",
  orderSales: "",
  model: "",
  orderName: "",
  orderStatus: [""],
  checkBox: false,
  orderDate: null,
  userInfoID: String(store.user_uid),
  userInfoName: "",
});
const searchOrderObj1 = reactive({ fuzzySearch: "" });
const clearableSearchObj = () => {
  searchOrderObj.Sources = "";
  searchOrderObj.ContactOwner = "";
  searchOrderObj.orderContact = "";
  searchOrderObj.orderCountry = "";
  searchOrderObj.orderType = "";
  searchOrderObj.orderType1 = "";
  searchOrderObj.orderSales = "";
  searchOrderObj.orderStatus = [""];
  searchOrderObj.checkBox = false;
  searchOrderObj.orderDate = null;
  searchOrderObj1.fuzzySearch = "";
  getOrderList(1, "", searchOrderObj.userInfoID);
};

const data = {
  token: store.token,
  page: "",
  rows: "",
  PI_name: "",
  country_id: "",
  customer_info_id: "",
  order_id: "",
  OrderType: "",
  id: "",
  is_team: "",
  status: 0,
  start_time: "",
  end_time: "",
  status_items: "",
  keyword: "",
  model: "",
  from_contact: "",
  is_settle: "",
  PI_type: "",
  website_id: "",
};
const getOrderObj = reactive({ orderList: [], loading: false });
const getOrderList = (val, info, ownerID, ownerName) => {
  selectList.value = []; //获取先清空选中数组
  orderID.value = "";
  getOrderObj.loading = true;
  if (info == "router") {
    data.order_id = routerID;
    searchOrderObj1.fuzzySearch = routerName;
    searchOrderObj.userInfoID = "";
    searchOrderObj.userInfoName = store.lang == "en-us" ? "All" : "所有";
    data.keyword = "";
    data.id = "";
  } else if (info == "New") {
    searchOrderObj.userInfoID = ownerID;
    searchOrderObj.userInfoName = ownerName;
    data.order_id = "";
    data.keyword = searchOrderObj1.fuzzySearch;
    data.id = searchOrderObj.userInfoID;
  } else if (info == "Team") {
    data.order_id = "";
    data.keyword = searchOrderObj1.fuzzySearch;
    data.id = searchOrderObj.userInfoID;
  } else {
    let array = teamList.value?.filter((item) => item.id == ownerID);
    searchOrderObj.userInfoID = ownerID ? ownerID : searchOrderObj.userInfoID;
    searchOrderObj.userInfoName = array[0]?.name
      ? array[0]?.name
      : searchOrderObj.userInfoName;
    data.order_id = "";
    data.keyword = searchOrderObj1.fuzzySearch;
    data.id = searchOrderObj.userInfoID;
  }
  data.page = val;
  data.rows = pageSize.value;
  data.model = searchOrderObj.model;
  data.PI_name = searchOrderObj.orderName;
  data.website_id = searchOrderObj.Sources;
  if (searchOrderObj.orderType == 3) {
    data.PI_type = 2;
    data.OrderType = "";
  } else {
    data.PI_type = searchOrderObj.orderType1;
    data.OrderType = searchOrderObj.orderType;
  }
  data.country_id = searchOrderObj.orderCountry;
  data.customer_info_id = searchOrderObj.orderContact;
  data.from_contact = searchOrderObj.checkBox ? 1 : 0;
  data.status = searchOrderObj.orderStatus && searchOrderObj.orderStatus[0];
  data.status_items =
    searchOrderObj.orderStatus && searchOrderObj.orderStatus[1];
  data.start_time = searchOrderObj.orderDate
    ? searchOrderObj.orderDate[0].replaceAll("-", "/")
    : "";
  data.end_time = searchOrderObj.orderDate
    ? searchOrderObj.orderDate[1].replaceAll("-", "/")
    : "";
  api.orderList(data).then((res) => {
    // 刷新重置显示条件，避免二次确定框出现
    isClentState.value = "";
    isOrderState.value = "";
    getOrderObj.loading = false;
    lastPage.value = res.data?.last_page;
    pageTotal.value = res.data?.total ? res.data?.total : 0;
    currentPage.value = res.data?.current_page;
    nextTick(() => {
      getOrderObj.orderList = res.data?.data?.map((item) => {
        item.checkState = false;
        item.isClentState = item.from_customer_poid > 0 ? 2 : 1;
        item.firstname = item.firstname ? Kernaldec(item.firstname) : "-";
        item.lastname = item.lastname ? Kernaldec(item.lastname) : "";
        item.clientName = `${item.firstname}${item.lastname}`;
        item.children = []
        return item;
      });
      if (info == "router" || info == "New") {
        store.changeOrderShow(true);
        orderID.value = getOrderObj.orderList[0]?.order_id
          ? getOrderObj.orderList[0]?.order_id
          : orderID.value; //三目运算防止新增owner为其他人时拿不到数据导致切换校验触发
        orderID1.value = getOrderObj.orderList[0]?.from_customer_poid
          ? getOrderObj.orderList[0]?.from_customer_poid
          : orderID1.value;
        isClentState.value = getOrderObj.orderList[0]?.isClentState
          ? getOrderObj.orderList[0]?.isClentState
          : isClentState.value;
        isOrderState.value = getOrderObj.orderList[0]?.PI_type
          ? getOrderObj.orderList[0]?.PI_type
          : isOrderState.value;
        let isReading = getOrderObj.orderList[0]?.is_read
          ? getOrderObj.orderList[0]?.is_read
          : 1;
        // ReadOrderMthods(orderID.value, isReading)
        getOrderObj.orderList?.forEach((item, index) => {
          if (index == 0 && item.PI_type != 2) {
            item.checkState = true;
            selectList.value = [];
            SelectionMethod(item, 2);
          }
        });
      }
    });
  });
};
// 上拉加载
const getOrderList1 = () => {
  if (getOrderObj.orderList?.length == 0 || data.page == lastPage.value)
    return false;
  data.page++;
  api.orderList(data).then((res) => {
    getOrderObj.orderList = [
      ...getOrderObj.orderList,
      ...res.data?.data?.map((item) => {
        item.checkState = false;
        item.isClentState = item.from_customer_poid > 0 ? 2 : 1;
        item.firstname = item.firstname ? Kernaldec(item.firstname) : "-";
        item.lastname = item.lastname ? Kernaldec(item.lastname) : "";
        item.clientName = `${item.firstname}${item.lastname}`;
        item.children = []
        return item;
      }),
    ];
    currentPage.value = res.data?.current_page;
    lastPage.value = res.data?.last_page;
    pageTotal.value = res.data?.total;
  });
};

//分页
const pageSize = ref(17);
const currentPage = ref(1);
const pageTotal = ref(0);
const lastPage = ref("");

const changeCurrPage = (val) => {
  getOrderList(val, "", searchOrderObj.userInfoID);
};
const changeSize = () => {
  getOrderList(1, "", searchOrderObj.userInfoID);
};

// 顶部模糊搜索
const topSearch = () => {
  utils.debounce(500, () => {
    getOrderList(1, "", searchOrderObj.userInfoID);
  });
};

// 精确搜索
const searchState = ref(false);
const searchOpen = () => {
  cancelRemove();
  searchState.value = true;
};
const searchWin = () => {
  getOrderList(1, "", searchOrderObj.userInfoID);
  searchState.value = false;
};
const resetSearchWin = () => {
  searchOrderObj.Sources = "";
  searchOrderObj.ContactOwner = "";
  searchOrderObj.orderCountry = "";
  searchOrderObj.orderContact = "";
  searchOrderObj.orderType = "";
  searchOrderObj.orderStatus = [""];
  searchOrderObj.orderDate = null;
  searchOrderObj.model = "";
  searchOrderObj.orderName = "";
  searchOrderObj.orderType1 = "";
};
/************ 获取订单结束 ************/

/************ 选择订单开始 ************/
const selectList = ref([]);
const selectOrderNames = ref("");
const selectOrderContacts = ref("");
const SelectionMethod = (val, type) => {
  if (type == 2) {
    if (selectList.value?.some((item) => item.order_id == val.order_id)) {
      //多选框再次点击表示删除
      selectList.value?.splice(
        selectList.value?.findIndex((item) => item.order_id == val.order_id),
        1
      );
    } else {
      if (val.PI_type == 2) return false;
      selectList.value.push(val);
    }
  } else {
    selectList.value = val;
  }
};
/************ 选择订单结束 ************/

/************ 订单操作开始 ************/
const salesOrderActionRef = ref();
const cancelRemove = () => {
  salesOrderActionRef.value.hide();
};
/************ 订单操作结束 ************/

/************ 订单发货开始 ************/
const deliverGoodsRef = ref();
const deliverGoodsOpen = () => {
  cancelRemove();
  if (!selectList.value?.length) {
    ElMessage({
      type: "info",
      message: i18n.global.t("Order.orderSelectShipOrder"),
    });
    return false;
  }
  deliverGoodsRef.value.getOrderInfos();
  selectList.value?.forEach((item) => {
    selectOrderNames.value += `${item.PI_name},`;
    selectOrderContacts.value += `${item.firstname}${item.lastname},`;
  });
  selectOrderNames.value = selectOrderNames.value?.slice(
    0,
    selectOrderNames.value?.length - 1
  );
  selectOrderContacts.value = selectOrderContacts.value?.slice(
    0,
    selectOrderContacts.value?.length - 1
  );
  selectOrderContacts.value = [
    ...new Set(selectOrderContacts.value?.split(",")),
  ].join(",");
};
// 发货后刷新详情页面

const companyDetailRef = ref();
const VendorDetailRef = ref();
const CompanyAfterSalesReshipmentDetailRef = ref();
/************ 订单发货结束 ************/

/************ 订单结算开始 ************/
const settleState = ref(false);
const changeSettleState = (state) => {
  settleState.value = state;
};
/************ 订单结算结束 ************/

/************ 订单结算详情开始 ************/
const settleDetailState = ref(false);
const changeSettleDetailState = (state) => {
  settleDetailState.value = state;
};
/************ 订单结算详情结束 ************/

/************ 获取订单详情开始 ************/
const leftBox = ref();
const leftBoxItem = ref();
const orderID = ref("");
const orderID1 = ref("");
const isClentState = ref("");
const isOrderState = ref("");
const CompanyCommissioDetailRef = ref();
const getOrderID = (row) => {
  // 第二页面相同id不执行
  if (store.orderShow && orderID.value == row.order_id) return false;
  let objA = {};
  let objB = {};
  if (isOrderState.value == 1 && isClentState.value == 1) {
    objA = companyDetailRef.value.returnData();
    objB = companyDetailRef.value.rawData;
  } else if (isOrderState.value == 1 && isClentState.value == 2) {
    objA = VendorDetailRef.value.returnData();
    objB = VendorDetailRef.value.rawData2;
  } else if (isOrderState.value == 2) {
    objA = CompanyCommissioDetailRef.value.returnData();
    objB = CompanyCommissioDetailRef.value.rawData1;
  } else if (isOrderState.value == 3) {
    objA = CompanyAfterSalesReshipmentDetailRef.value.returnData();
    objB = CompanyAfterSalesReshipmentDetailRef.value.rawData3;
  }
  if (!utils.isObjectValueEqual(objA, objB)) {
    ElMessageBox.confirm(
      i18n.global.t("Order.orderEditInformation"),
      i18n.global.t("Order.orderTips"),
      {
        confirmButtonText: i18n.global.t("Order.orderConfirm"),
        cancelButtonText: i18n.global.t("Order.orderCancel"),
        type: "warning",
      }
    )
      .then(() => {
        isClentState.value = row.isClentState;
        isOrderState.value = row.PI_type;
        orderID.value = row.order_id;
        orderID1.value = row.from_customer_poid;
        let isReading = row.is_read;
        getOrderObj.orderList?.forEach((item) => {
          if (row.order_id == item.order_id && row.PI_type != 2) {
            //单选时选择不同的采购单清空勾选数组
            item.checkState = true;
          } else {
            item.checkState = false;
          }
        });
        selectList.value = []; //切换销售单先清空数组，避免不同采购禁止选择
        ReadOrderMthods(orderID.value, isReading);
        if (row.PI_type != 2) {
          SelectionMethod(row, 2);
        }
      })
      .catch(() => {
        console.log("不关闭");
      });
  } else {
    isClentState.value = row.isClentState;
    isOrderState.value = row.PI_type;
    orderID.value = row.order_id;
    orderID1.value = row.from_customer_poid;
    let isReading = row.is_read;
    getOrderObj.orderList?.forEach((item) => {
      if (row.order_id == item.order_id && row.PI_type != 2) {
        //单选时选择不同的采购单清空勾选数组
        item.checkState = true;
      } else {
        item.checkState = false;
      }
    });
    selectList.value = []; //切换销售单先清空数组，避免不同采购禁止选择
    ReadOrderMthods(orderID.value, isReading);
    if (row.PI_type != 2) {
      SelectionMethod(row, 2);
    }
  }
  if (!store.orderShow) {
    leftBoxItem.value?.forEach((item) => {
      nextTick(() => {
        if (item.className == "list flex aic success-row") {
          leftBox.value.scrollTo({
            top: item.offsetTop - 148,
            behavior: "smooth",
          });
        }
      });
    });
    store.changeOrderShow(true);
  }
};

const matchCurrentRow = () => {
  leftBox.value.scrollTop = 0;
};

//  编辑后修改前端订单数量
const editOrderDetail = (OrderItems, OrderTypeID, clientName, ownerName) => {
  let clientArray = String(clientName)?.split("\u200B");
  getOrderObj.orderList?.forEach((item) => {
    if (item.order_id == orderID.value) {
      // item.items = OrderItems ? OrderItems : item.items
      item.qty_total = OrderItems ? OrderItems : item.items;
      item.OrderType = OrderTypeID ? OrderTypeID : item.OrderType;
      item.clientName = clientName
        ? `${clientArray[0]}${clientArray[1] ? clientArray[1] : ""}`
        : item.clientName;
      item.user_name = ownerName ? ownerName : item.user_name;
      if (OrderTypeID == 1) {
        item.OrderType_text = i18n.global.t("Order.sOrderTypeWholesale");
      } else if (OrderTypeID == 2) {
        item.OrderType_text = i18n.global.t("Order.sOrderTypeRetail");
      } else {
        item.OrderType_text = item.OrderType_text;
      }
    }
  });
};
// 订货后修改订单状态
const editOrderState = (state, stateText) => {
  getOrderObj.orderList?.forEach((item) => {
    if (item.order_id == orderID.value) {
      //2 i18n.global.t('Order.sOrderStateUnderway')
      //3 i18n.global.t('Order.sOrderStateCompleted')
      item.status_text = stateText;
      item.status = state;
    }
  });
};
// 订单已读标记
const ReadOrderMthods = (orderID, isReading) => {
  if (isReading == 1) return false;
  api.ordersRead({ token: store.token, order_id: orderID }).then((res) => {
    if (res.Status == 0) {
      getOrderObj.orderList?.forEach((item) => {
        if (item.order_id == orderID) {
          item.is_read = 1;
        }
      });
    }
  });
};
/************ 获取订单详情结束 ************/

/************ 删除订单开始 ************/
const DeleteOrder = () => {
  const index = getOrderObj.orderList?.findIndex(
    (item) => item.order_id == orderID.value
  );
  getOrderObj.orderList?.splice(index, 1);
  const isIndex = getOrderObj.orderList?.length - 1;
  if (getOrderObj.orderList?.length) {
    if (index > isIndex) {
      orderID.value = getOrderObj.orderList[index - 1].order_id;
      orderID1.value = getOrderObj.orderList[index - 1].from_customer_poid;
    } else {
      orderID.value = getOrderObj.orderList[index].order_id;
      orderID1.value = getOrderObj.orderList[index].from_customer_poid;
    }
  } else {
    orderID.value = "";
    orderID1.value = "";
  }
};
/************ 删除订单结束 ************/

/************ 产品全删除后删除订单列表子组件触发开始 ************/
const delOrderListItem = (delNumber, productNumber) => {
  if (delNumber == productNumber) {
    const index = getOrderObj.orderList?.findIndex(
      (item) => item.order_id == orderID.value
    );
    getOrderObj.orderList?.splice(index, 1);
    const isIndex = getOrderObj.orderList.length - 1;
    if (getOrderObj.orderList?.length) {
      if (index > isIndex) {
        orderID.value = getOrderObj.orderList[index - 1].order_id;
        orderID1.value = getOrderObj.orderList[index - 1].from_customer_poid;
      } else {
        orderID.value = getOrderObj.orderList[index].order_id;
        orderID1.value = getOrderObj.orderList[index].from_customer_poid;
      }
    } else {
      orderID.value = "";
      orderID1.value = "";
    }
  } else {
    getOrderObj.orderList?.forEach((item) => {
      if (item.order_id == orderID.value) {
        item.items = item.items - delNumber;
      }
    });
  }
};
/************ 产品全删除后删除订单列表子组件触发结束 ************/

/************ 获取团队数据开始 ************/
const teamList = ref([
  { id: "", name: store.lang == "en-us" ? "All" : "所有" },
  { id: String(store.user_uid), name: store.lang == "en-us" ? "My" : "我的" },
]);

const teamData = {
  token: store.token,
  group: 1,
  name: "",
  source: "orders",
  page: "",
  pageSize: 30,
};
const getTeamList = () => {
  teamData.page = 1;
  api.ordersConfigGetTeam(teamData).then((res) => {
    let array = res.data?.data;
    teamLastPage.value = res.data?.last_page;
    array?.splice(
      array?.findIndex((item) => String(item.id) == String(store.user_uid)),
      1
    ); //把团队数据里自己的id删除
    teamList.value = [...teamList.value, ...array];
    console.log(store.user_uid);
  });
};

const getTeamList1 = (val) => {
  teamData.page = 1;
  teamData.name = val;
  api.ordersConfigGetTeam(teamData).then((res) => {
    teamLastPage.value = res.data?.last_page;
    if (val) {
      teamList.value = res.data?.data;
    } else {
      let array = res.data?.data;
      let array1 = [
        { id: "", name: store.lang == "en-us" ? "All" : "所有" },
        {
          id: String(store.user_uid),
          name: store.lang == "en-us" ? "My" : "我的",
        },
      ];
      array?.splice(
        array?.findIndex((item) => String(item.id) == String(store.user_uid)),
        1
      ); //把团队数据里自己的id删除
      teamList.value = [...array1, ...array];
    }
  });
};
const teamLastPage = ref(0);
const getTeamList2 = () => {
  if (teamLastPage.value == teamData.page) return false;
  teamData.page++;
  api.ordersConfigGetTeam(teamData).then((res) => {
    let array = res.data?.data;
    teamLastPage.value = res.data?.last_page;
    array?.splice(
      array?.findIndex((item) => String(item.id) == String(store.user_uid)),
      1
    ); //把团队数据里自己的id删除
    teamList.value = [...teamList.value, ...array];
  });
};

const getTeamUserID = (val) => {
  searchOrderObj.userInfoID = val.id;
  searchOrderObj.userInfoName = val.name;
  getOrderList(1, "Team", searchOrderObj.userInfoID);
};
/************ 获取团队数据结束 ************/
/************ 获取状态列表开始 ************/
const props1 = { checkStrictly: true };
const statusList = computed(() => {
  return [
    {
      value: 1,
      label: i18n.global.t("Order.sOrderStateTobestarted"),
      children: [],
    },
    {
      value: 2,
      label: i18n.global.t("Order.sOrderStateUnderway"),
      children: [
        {
          value: 1,
          label: i18n.global.t("Order.sOrderStateAllocationorder"),
        },
        {
          value: 2,
          label: i18n.global.t("Order.sOrderStateOnassignment"),
        },
        {
          value: 3,
          label: i18n.global.t("Order.sOrderStateGeneraldelivery"),
        },
        {
          value: 4,
          label: i18n.global.t("Order.sOrderStateLogisticsdocumentary"),
        },
        {
          value: 8,
          label: i18n.global.t("Order.sOrderStateIncoming"),
        },
      ],
    },
    {
      value: 3,
      label: i18n.global.t("Order.sOrderStateCompleted"),
      children: [],
    },
  ];
});
// 选中状态关闭下拉框
const addressLevelRef = ref();
const closeAddRess1 = () => {
  addressLevelRef.value.togglePopperVisible();
  getOrderList(1, "", searchOrderObj.userInfoID);
};
const closeAddRess2 = () => {
  addressLevelRef.value.togglePopperVisible();
};
/************ 获取状态列表结束 ************/
/************ 获取类型列表开始 ************/
const orderTypeList = computed(() => {
  return [
    { id: 1, name: i18n.global.t("Order.sOrderTypeWholesale") },
    { id: 2, name: i18n.global.t("Order.sOrderTypeRetail") },
    { id: 3, name: i18n.global.t("Order.sOrderTypecommission") },
  ];
});
/************ 获取类型列表结束 ************/
/************ 获取订单类型列表开始 ************/
const orderTypeList1 = computed(() => {
  return [
    { type: 1, typeText: i18n.global.t("Order.salesOrder1") },
    { type: 2, typeText: i18n.global.t("Order.salesOrder2") },
    { type: 3, typeText: i18n.global.t("Order.salesOrder3") },
  ];
});
/************ 获取订单类型列表结束 ************/
/************ 获取公共数据列表开始 ************/
const modelList = ref(pubData.modelList);
const shortcuts = ref(pubData.shortcuts);
const countryList = ref(pubData.countryList);
const selectLoading = ref(pubData.selectLoading);
const orderFromList = ref(pubData.orderFromList);
// const orderFromList = ref(pubData.orderFromList);
const userList = ref(pubData.clentAndSupperList);
/************ 获取公共数据列表结束 ************/

const { toClipboard } = useClipboard(); //剪切板
const copyInfo = ref("");
const copyText = (info) => {
  copyInfo.value = info;
  try {
    toClipboard(copyInfo.value);
    ElMessage({
      message: i18n.global.t("Order.orderReplication"),
      type: "success",
    });
  } catch (e) {
    console.error(e);
  }
};

//视口
const windowWidth = ref(window.innerWidth);
const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

const isShowTooltip = ref(true);
const getWidth = (event) => {
  if (event.target.scrollWidth > event.target.clientWidth) {
    isShowTooltip.value = false;
  } else {
    isShowTooltip.value = true;
  }
};

onMounted(() => {
  getTeamList();
  if (routerID) {
    getOrderList(1, "router", searchOrderObj.userInfoID);
  } else {
    getOrderList(1, "", searchOrderObj.userInfoID);
  }
  // window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  // window.removeEventListener("resize", handleResize);
});
</script>
<style lang="less" scoped>
@import "./less/salesOrder.less";
@import "./less/pubTableCss.less";
.MSGsalesOrder {
  .Tip {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
